<!-- @component `Article` A wrapper for the story. -->
<script lang="ts">
	// IMPORT
	import { error } from '@sveltejs/kit';

	// PROPS
	/** Add an id to the article tag to target it with custom CSS. */
	export let id: string | null = null;

	// LOGIC
</script>

<main>
	<article {id}>
		<!-- Article content -->
		<slot />
	</article>
</main>

<style lang="scss">
	@use '$styles/global' as *;
	article {
		display: block;
		margin: 0;
		background-color: var(--theme-color-background, transparent);
		padding: $navbar-height 0 0 0;
	}
</style>
